// extracted by mini-css-extract-plugin
module.exports = {"footer":"MutateMid_footer__dx1Ig","legacyBtn":"MutateMid_legacyBtn__207sx"};